import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { SingleLineTruncate } from '../../../../../../components/LineTruncate';

import css from './CourseDetail.module.scss';

interface Props {
  menuName: string;
  price?: string;
  duration?: number; // second
}

const CourseDetail: React.FC<Props> = ({
  menuName,
  price,
  duration,
}: Props) => {
  const classes = classNames(css.CourseDetail);
  const intl = useIntl();

  return (
    <div className={classes}>
      <SingleLineTruncate maxLine={2} text={menuName} />
      <span className={css.CourseDetail__Detail}>
        {duration && (
          <span className={css.CourseDetail__Time}>
            <FormattedMessage
              id="merchants.bookingPages.courseDetail.time"
              values={{ time: intl.formatNumber(duration / 60) }}
            />
          </span>
        )}
        {price && (
          <FormattedMessage
            id="merchants.bookingPages.courseDetail.price"
            values={{ price }}
          />
        )}
      </span>
    </div>
  );
};

export default CourseDetail;
